import React, { useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Container
} from '@mui/material';

// const Login: React.FC = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const { login, isAuthenticated } = useAuth();
//   const navigate = useNavigate();

const Login: React.FC = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // If already logged in, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setError('');
  //   setIsLoading(true);

  const handleLogin = async () => {
    setError('');
    setIsLoading(true);

    try {
      const next = (location.state as any)?.from || '/';
      const success = await login(next);
      if (success) {
        navigate('/');
      } else {
        setError('Invalid credentials. Please use your DAC account to login.');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            maxWidth: 400
          }}
        >
          {/* <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              Keyword Classifier
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Sign in to access the dashboard
            </Typography>
          </Box> */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              TotalSERP
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Sign in with your Azure AD account to continue
            </Typography>
          </Box>

          {/* <form onSubmit={handleSubmit}>
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username (admin)"
                required
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password (admin)"
                required
              />
            </Box> */}

            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            <Button
            fullWidth
            variant="contained"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign in with Azure AD'}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

//             <Button
//               fullWidth
//               variant="contained"
//               type="submit"
//               disabled={isLoading}
//               sx={{ mb: 2 }}
//             >
//               {isLoading ? 'Signing in...' : 'Sign in'}
//             </Button>

//             <Typography variant="body2" color="text.secondary" align="center">
//               For demonstration purposes, use:
//               <br />
//               Username: <strong>admin</strong>
//               <br />
//               Password: <strong>admin</strong>
//             </Typography>
//           </form>
//         </Paper>
//       </Box>
//     </Container>
//   );
// };

export default Login;